export interface AttributeValue {
    id?: string;
    value?: string;
    name?: string;
    count?: string;
    userValue?: string;
}
